<template>
  <div class="date_select">
    <input type="hidden" :name="inputName" :value="innerValue">
    <div class="field_group date_day_set">
      <div class="select_ui date_year">
        <select v-model="year" @change="changeValue">
          <option v-for="(v) in options.years" v-bind:value="v.value">{{ v.label }}</option>
        </select>
      </div><!-- /.select_ui -->
      <div class="select_ui date_month">
        <select v-model="month" @change="changeValue">
          <option v-for="(v) in options.months" v-bind:value="v.value">{{ v.label }}</option>
        </select>
      </div><!-- /.select_ui -->
      <div class="select_ui date_day">
        <select v-model="day" @change="changeValue">
          <option v-for="(v) in options.days" v-bind:value="v.value">{{ v.label }}</option>
        </select>
      </div><!-- /.select_ui -->
    </div><!-- /.date_day_set -->
    <div class="field_group date_time_set" v-if="this.withTime">
      <div class="select_ui date_hour">
        <select v-model="hour" @change="changeValue">
          <option v-for="(v) in options.hours" v-bind:value="v.value">{{ v.label }}</option>
        </select>
      </div><!-- /.select_ui -->
      <span class="date_time_addon">:</span>
      <div class="select_ui date_min">
        <select v-model="minute" @change="changeValue">
          <option v-for="(v) in options.minutes" v-bind:value="v.value">{{ v.label }}</option>
        </select>
      </div><!-- /.select_ui -->
    </div><!-- /.date_time_set -->
  </div>
</template>

<script>
  import {sprintf} from 'sprintf-js'
  import moment from 'moment'

  export default {
    props: {
      inputName: {
        type: String,
        default: '',
      },
      yearMin: {
        type: Number,
        default: 1950
      },
      yearMax: {
        type: Number,
        default: 2050
      },
      withWareki: {
        type: Boolean,
        default: false
      },
      withTime: {
        type: Boolean,
        default: true
      },
      value:{
        type: String,
        default: 'YYYY-MM-DD HH:mm',
      },
    },
    data() {
      return {
        options: {
          years: this.getYearsList(),
          months: this.getMonthsList(),
          days: this.getDaysList(),
          hours: this.getHoursList(),
          minutes: this.getMinutesList()
        },
        year: '',
        month: '',
        day: '',
        hour: '',
        minute: '',
        innerValue: '',
      }
    },
    created() {
      this.initValue()
    },
    methods: {
      initValue() {
        let dt = moment(this.value)

        if (dt.isValid()) {
          this.year = dt.year()
          this.month = dt.month() + 1
          this.day = dt.date()
          if (this.withTime) {
            this.hour = dt.hour()
            this.minute = dt.minute()
            this.innerValue = dt.format('YYYY-MM-DD HH:mm:00')
          } else {
            this.innerValue = dt.format('YYYY-MM-DD')
          }
        } else {
          this.innerValue = '';
        }
      },
      changeValue() {
        let value = ''

        if (this.year.length === 0 || this.month.length === 0 || this.day.length === 0) {
          this.innerValue = value;
          return
        }

        value = sprintf('%04d-%02d-%02d', this.year, this.month, this.day)

        if (this.withTime ) {
          if (this.hour.length === 0 || this.minute.length === 0) {
            this.innerValue = value;
            return
          }
          value += sprintf(' %02d:%02d:%02d', this.hour, this.minute, 0)
        }

        this.innerValue = value;
        this.$emit('input', this.innerValue)
      },
      getYearsList() {
        let list = [];
        list.push({value: '', label: '年'})

        for (let i = this.yearMin; i <= this.yearMax; i++) {
          if (this.withWareki) {
            let wareki = this.getWareki(i)
            list.push({value: i, label: sprintf('%04d (%s%02d)', i, wareki.gengo, wareki.year)})
          } else {
            list.push({value: i, label: sprintf('%04d', i)})
          }
        }

        return list;
      },
      getMonthsList() {
        let list = [];
        list.push({value: '', label: '月'})

        for (let i = 1; i <= 12; i++) {
          list.push({value: i, label: sprintf('%02d', i)})
        }

        return list;
      },
      getDaysList() {
        let list = [];
        list.push({value: '', label: '日'})

        for (let i = 1; i <= 31; i++) {
          list.push({value: i, label: sprintf('%02d', i)})
        }

        return list;
      },
      getHoursList() {
        let list = [];
        list.push({value: '', label: '時'})

        for (let i = 0; i <= 59; i++) {
          list.push({value: i, label: sprintf('%02d', i)})
        }

        return list;
      },
      getMinutesList() {
        let list = [];
        list.push({value: '', label: '分'})

        for (let i = 0; i <= 59; i++) {
          list.push({value: i, label: sprintf('%02d', i)})
        }

        return list;
      },
      getWareki(year) {
        let ret = null

        if (year > 2018) {
          ret = {gengo: '令和', year: year - 2018}
        } else if (year > 1988) {
          ret = {gengo: '平成', year: year - 1988}
        } else if (year > 1925) {
          ret = {gengo: '昭和', year: year - 1925}
        } else if (year > 1911) {
          ret = {gengo: '大正', year: year - 1911}
        } else if (year > 1867) {
          ret = {gengo: '明治', year: year - 1867}
        }

        return ret
      }
    },
  }
</script>
